module.exports = __webpack_public_path__ + "static/media/sam_kirschner.aec412e9.jpeg";